import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ExportApi from "../../api/ExportApi";
import { toast } from "react-toastify";

// Function to fetch the filters
export const fetchFilters = createAsyncThunk("filters/fetchFilters", async () => {
   try{
     const resp = await ExportApi.GetFilterData();
    return resp.data.data;
   }
   catch(err){
    toast.error("An error occurred")
   }
});

const filtersSlice = createSlice({
    name: "filters",
    initialState: {
        brands: [],
        chipset: [],
        condition: [],
        model: [],
        series: [],
        loading: false,
        error: null,
    },
    reducers: {}, // Add the filter actions here 
    extraReducers: (builder) => {
        builder
            .addCase(fetchFilters.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchFilters.fulfilled, (state, action) => {
                state.loading = false;
                state.brands = action.payload.brands || [];
                state.chipset = action.payload.chipset || [];
                state.condition = action.payload.condition || [];
                state.model = action.payload.model || [];
                state.series = action.payload.series || [];
            })
            .addCase(fetchFilters.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default filtersSlice.reducer;
